import { useMemo, type ReactNode } from 'react'
import { usePricingQuoteSync } from '~/utils/pricingQuote'
import { computeWorkTableParts } from '~/utils/workTableParts'
import { QuoteProvider } from '~/context/pricingQuoteContext'

interface WorkTableQuoteProviderProps {
  sku: string
  chipboardId?: string
  width: number
  height: number
  depth: number
  hasDrawers: boolean
  drawerCount: number
  children: ReactNode
}

export function WorkTableQuoteProvider({
  sku,
  chipboardId,
  width,
  height,
  depth,
  hasDrawers,
  drawerCount,
  children,
}: WorkTableQuoteProviderProps) {
  const { panels } = useMemo(
    () => computeWorkTableParts({ width, height, depth, hasDrawers, drawerCount }),
    [width, height, depth, hasDrawers, drawerCount]
  )

  const zones = useMemo(() => {
    if (!hasDrawers) return []
    return [{ type: 'drawers', drawers: drawerCount, shelves: 0 }]
  }, [hasDrawers, drawerCount])

  const quote = usePricingQuoteSync({
    sku,
    chipboardId,
    width,
    height,
    depth,
    handleType: 'push',
    doorsNumber: 0,
    sections: 1,
    parts: panels,
    zones,
  })

  return <QuoteProvider value={quote}>{children}</QuoteProvider>
}
